<template>
  <div class="w-full flex-col items-start gap-10">
    <div class="flex items-center flex-1">
      <ul class="flex items-center justify-start gap-2 overflow-x-auto">
        <li v-for="(tab) in tabHeaders" :key="tab.id" class="mr-1">
          <button
            class="px-4 py-3 flex items-center justify-start gap-1 bg-transparent text-white rounded-full text-lg font-semibold whitespace-nowrap outline-none"
            :class="{ 'bg-dark-purple-background': currentTab === tab.id }" @click="currentTab = tab.id">
            {{ tab.name }} <span v-if="tab.count" class="text-xs text-gray-300">({{ tab.count | formatNumber
            }})</span>
          </button>
        </li>
      </ul>
      <slot name="actions"></slot>
    </div>
    <div class="pt-10">
      <slot :name="currentTab"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabHeaders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentTab: this.tabHeaders[0].id
    }
  },
  filters: {
    formatNumber(value) {
      if (!value) return '0'
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>